<template>
  <div class="allSubjectContent">
    <headers
      class="herderNav"
      ref="header"
      :isChange="false"
    />
    <div class="allSubjectNav">
      <div class="subjectNavBack"></div>
      <div class="subjectNavCon">
        <div class="bg"></div>
        <div class="userInfos">
          <div class="userImgs">
            <el-image
              style="border-radius: 50%; background-color: #efefef"
              :src="
                userinfo.avatar_url === '/static/img/avatar_photo.png'
                  ? $headImgUrl
                  : userinfo.avatar_url
              "
              fit="cover"
            >
              <div
                slot="error"
                class="image-slot"
              ></div>
            </el-image>
          </div>
          <div class="userTits">
            <div class="userTitsNav">
              <span>{{ userinfo.nick }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="switchTab">
        <!-- tab切换 -->
        <ul>
          <li
            v-for="(ele, index) in switchTab"
            :key="index"
            :class="n == ele.type ? 'active' : ''"
            @click="switchTabs(ele.type)"
          >
            {{ ele.name }}
          </li>
        </ul>
        <div class="switchTabCons">
          <!-- 选择种类 Card -->
          <!-- <div class="switchCard">
            <ul>
              <li class="titsBtnAcitve" v-if="titls">{{titlsTit}}</li>
            </ul>
            <div class="switchBox">
              <div class="switchCardCons" v-for="(item,indexs) in tablist" :key="indexs">
                <div class="subjectTits">{{item.tits}}:</div>
                <div class="subjectBtns">
                  <div v-for="(btns,inbtn) in item.allBtns" :key="inbtn" @click="checkBtn(inbtn)" :class="m == inbtn ? 'checkBtns':''">{{btns}}</div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- 练习记录 -->
          <div
            class="practiceResult"
            v-for="(cardScore, indexScore) in recordStatus"
            :key="indexScore"
            v-if="practiceNote"
          >
            <div class="practiceNav">
              {{ cardScore.mockexam }}({{
                cardScore.isend === 0 ? "未完成" : "已完成"
              }})
            </div>
            <div class="practiceCon">
              <div class="practiceConLeft">
                <div>
                  <p>{{ cardTit.scoreTit }}</p>
                  <p v-if="exerciseData">
                    <a>{{ cardScore.count }}</a>
                  </p>
                  <p v-if="examData">
                    <a>{{ cardScore.done }}</a>
                  </p>
                </div>
                <div>
                  <p>{{ cardTit.finishTit }}</p>
                  <p v-if="exerciseData">
                    <a>{{ cardScore.done }}</a>
                  </p>
                  <p v-if="examData">
                    <a>{{ cardScore.surplus }}</a>
                  </p>
                </div>
                <div>
                  <p>{{ cardTit.tChance }}</p>
                  <p v-if="exerciseData">
                    <a>{{ cardScore.average }}</a>
                  </p>
                  <p v-if="examData">
                    <a>{{ cardScore.accuracy }}</a>
                  </p>
                </div>
                <div>
                  <p>{{ cardTit.evaChance }}</p>
                  <p v-if="exerciseData">{{ cardScore.myaverage }}</p>
                  <p v-if="examData">
                    <a>{{ cardScore.ctime }}</a>
                  </p>
                </div>
                <div>
                  <p>{{ cardTit.time }}</p>
                  <p>
                    <a>{{ cardScore.usetime }}s</a>
                  </p>
                </div>
              </div>
              <div
                class="practiceConRight"
                @click="viewResults(cardScore.id, cardScore.m_id)"
              >
                <div>查看结果</div>
              </div>
            </div>
          </div>

          <!-- 收藏夹  -->
          <div
            class="collection"
            v-if="errBook"
          >
            <div
              v-for="(errs, indexErr) in mySubject"
              :key="indexErr"
            >
              <div
                class="collectBtn"
                v-if="errCollect"
                @click="nav(errs.id)"
              >
                错题练习
              </div>
              <div class="collectCard">
                <p
                  class="cardTits"
                  @click="nav(errs.id)"
                >{{ errs.title }}</p>
                <p
                  class="cardFroms"
                  @click="nav(errs.id)"
                >
                  来源：{{ errs.title }}
                </p>
                <div class="cardContents">{{ errs.stem }}</div>
                <div class="cardBottom">
                  <p>{{ errs.peoplenum }}人做过</p>
                  <div>
                    <img
                      v-show="errs.collect == 0"
                      @click="needCollect(errs.id)"
                      src="../../assets/allSubject/cancelCollect.png"
                      alt=""
                    />
                    <span v-show="errs.collect == 0">未收藏</span>
                    <img
                      v-show="errs.collect == 1"
                      @click="unNeedCollect(errs.id)"
                      src="../../assets/allSubject/choiceCollect.png"
                    />
                    <span v-show="errs.collect == 1">取消收藏</span>
                    <button
                      v-if="errRemove"
                      @click="remove(errs.id)"
                    >
                      移除错题
                    </button>
                    <div
                      class="cancelCollect"
                      v-if="collectRemove"
                      @click="cancleCollect(errs.id)"
                    >
                      <img src="../../assets/allSubject/choiceCollect.png" />
                      <span>取消收藏</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-pagination
              background
              layout="total,prev, pager, next"
              @current-change="choiceTag"
              :total="total"
              :current-page="page"
              :page-size="limit"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/record.js";
import headers from "../../components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      //练习记录的数据
      exerciseData: true,
      //模考记录的数据
      examData: false,
      navCodes: require("@/assets/login/navCode.png"),
      n: 1,
      m: 0,
      titls: true,
      //练习记录内容
      practiceNote: true,
      //错题本，收藏夹
      errBook: false,
      //错题错题练习
      errCollect: true,
      //错题 移除错题
      errRemove: true,
      //收藏夹 移除错题
      collectRemove: true,
      titlsTit: "练习记录",
      tablist: [],
      switchTab: [
        {
          name: "练习记录",
          type: 1,
        },
        {
          name: "模考记录",
          type: 2,
        },
        {
          name: "收藏夹",
          type: 3,
        },
        {
          name: "错题本",
          type: 4,
        },
      ],
      //练习记录
      practiceNotes: [
        {
          tits: "练习状态",
          allBtns: ["全部", "已完成", "未完成"],
        },
        {
          tits: "时间选择",
          allBtns: ["全部", "今天", "一周内", "一个月内", "三个月内"],
        },
        {
          tits: "材料选择",
          allBtns: [
            "全部",
            "OG",
            "PREP",
            "PREP",
            "OG",
            "PREP",
            "OG",
            "PREP",
            "OG",
          ],
        },
        {
          tits: "科目分类",
          allBtns: [
            "全部",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
          ],
        },
      ],
      //收藏
      Collection: [
        {
          tits: "科目选择",
          allBtns: ["全部", "已完成", "未完成"],
        },
        {
          tits: "来源选择",
          allBtns: [
            "全部",
            "OG",
            "PREP",
            "PREP",
            "OG",
            "PREP",
            "OG",
            "PREP",
            "OG",
          ],
        },
        {
          tits: "收藏时间",
          allBtns: ["全部", "今天", "一周内", "一个月内", "三个月内"],
        },
      ],
      //错题本
      errLibrary: [
        {
          tits: "收藏时间",
          allBtns: ["全部", "已完成", "未完成"],
        },
        {
          tits: "材料选择",
          allBtns: [
            "全部",
            "OG",
            "PREP",
            "PREP",
            "OG",
            "PREP",
            "OG",
            "PREP",
            "OG",
          ],
        },
        {
          tits: "科目分类",
          allBtns: [
            "全部",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
            "SC语法",
            "CR逻辑",
          ],
        },
        {
          tits: "做错次数",
          allBtns: ["全部", "做错1次", "做错2次", "做错3次"],
        },
      ],
      //练习记录情况
      recordStatus: [],
      //收藏夹，错题集
      mySubject: [],
      exercise: {
        scoreTit: "题目总数",
        finishTit: "完成题目数",
        tChance: "平均正确率",
        evaChance: "我的正确率",
        time: "平均每耗时",
      },
      exam: {
        scoreTit: "完成题目数",
        finishTit: "剩余题目数",
        tChance: "正确率",
        evaChance: "开始时间",
        time: "用时",
      },
      cardTit: {},
    };
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  methods: {
    switchTabs(type) {
      this.n = type;
      if (this.n == 1) {
        this.tablist = this.practiceNotes;
        this.titls = this.practiceNote = this.exerciseData = true;
        this.titlsTit = "练习记录";
        this.errBook = this.examData = false;
        this.getExercise();
        this.cardTit = this.exercise;
      }
      if (this.n == 2) {
        this.getExam();
        this.cardTit = this.exam;
        this.tablist = this.practiceNotes;
        this.titls = this.practiceNote = this.examData = true;
        this.errBook = this.exerciseData = false;
      }
      if (this.n == 3) {
        this.tablist = this.Collection;
        this.titls = this.errBook = this.collectRemove = true;
        this.titlsTit = "题目收藏";
        this.practiceNote = this.errCollect = this.errRemove = false;
        this.getTopic();
      }
      if (this.n == 4) {
        this.tablist = this.errLibrary;
        this.titls = this.practiceNote = this.collectRemove = false;
        this.errBook = this.errCollect = this.errRemove = true;
        this.getError();
      }
    },
    nav(id) {
      this.$router.push(`/libraryContent/${id}`);
    },
    checkBtn(index) {
      this.m = index;
    },
    viewResults(id, m_id) {
      if (this.exerciseData) {
        sessionStorage.setItem("curId", id);
        sessionStorage.setItem("m_id", m_id);
        this.$router.push("/exerciseResult");
      } else {
        sessionStorage.setItem("curId", id);
        sessionStorage.setItem("m_id", m_id);
        this.$router.push("/scheduleMatter");
      }
    },
    //错题本收藏
    needCollect(id) {
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      api.joinCollect(query).then((res) => {
        this.getError();
      });
    },
    //取消收藏 => 错题本
    unNeedCollect(id) {
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      api.outCollect(query).then((res) => {
        this.getError();
      });
    },
    //取消收藏 => 收藏夹
    cancleCollect(id) {
      let params = {
        id: id,
      };
      let query = this.$qs.stringify(params);
      api.outCollect(query).then((res) => {
        this.getTopic();
      });
    },
    //获取练习记录
    getExercise() {
      api.exercise().then((res) => {
        this.recordStatus = res.data.data;
      });
    },
    //获取模考记录
    getExam() {
      api.mockexam().then((res) => {
        this.recordStatus = res.data.data;
        console.log(res);
      });
    },
    //获取错题本
    getError(page) {
      this.page = page;
      let params = {
        page: this.page,
        limit: this.limit,
      };
      let query = this.$qs.stringify(params);
      api.error(query).then((res) => {
        this.mySubject = res.data.data;
        this.total = res.data.count;
      });
    },
    choiceTag(ele) {
      this.page = ele;
      if (this.n == 4) {
        this.getError(this.page);
      } else {
        this.getTopic(this.page);
      }
    },
    //移除错题本
    remove(id) {
      this.$confirm("确认移除该错题吗？")
        .then((_) => {
          api
            .remove({
              id,
            })
            .then((res) => {
              this.getError();
            })
            .catch((err) => {
              this.$message.error(err.msg || err);
            });
        })
        .catch((_) => {});
    },
    //获取收藏夹
    getTopic(page = 1) {
      this.page = page;
      let params = {
        page: this.page,
        limit: this.limit,
      };
      let query = this.$qs.stringify(params);
      api.topic(query).then((res) => {
        this.mySubject = res.data.data;
        this.total = res.data.count;
      });
    },
  },
  mounted() {
    this.$refs.header.headerBack = {
      backgroundColor: "#fff",
    };
    this.$refs.header.herderTits = {
      color: "rgb(102,102,102)",
    };
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    if (localStorage.getItem("token")) {
      this.tablist = this.practiceNotes;
      this.cardTit = this.exercise;
      this.getExercise();
    } else if (sessionStorage.getItem("token")) {
      this.tablist = this.practiceNotes;
      this.cardTit = this.exercise;
      this.getExercise();
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
@import url("../../assets/css/allsubjectcontent.css");
</style>



// WEBPACK FOOTER //
// src/view/allSubjectContent/allsubjectcontent.vue